export default "__VITE_ASSET__CiMt_6Lp__"